import { render, staticRenderFns } from "./EnergyView.vue?vue&type=template&id=a8f6fed2&scoped=true"
import script from "./EnergyView.vue?vue&type=script&lang=js"
export * from "./EnergyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f6fed2",
  null
  
)

export default component.exports